import { PublicProfile } from "../processes/PublicProfile/PublicProfile";

export const PublicProfileRouter = PublicProfile;
